import { Dispatch, SetStateAction } from 'react';

import { Technology } from 'modules/chains/constants';

import { SnippetTechnologyTabs } from '../SnippetTechnologyTabs';
import { Snippets } from '../Snippets';
import { useConnectionSnippetStyles } from './useConnectionSnippetStyles';

export interface ConnectionSnippetProps {
  hasFullWidthSnippets?: boolean;
  httpCode: string;
  isTitleHidden?: boolean;
  placeholder?: React.ReactNode;
  setTechnology: Dispatch<SetStateAction<Technology>>;
  technology: Technology;
  wssCode?: string;
}

export const ConnectionSnippet = ({
  hasFullWidthSnippets,
  httpCode,
  isTitleHidden,
  placeholder,
  setTechnology,
  technology,
  wssCode,
}: ConnectionSnippetProps) => {
  const { classes } = useConnectionSnippetStyles();

  return (
    <div
      className={classes.root}
      tabIndex={0}
      role="button"
      onClick={e => e.stopPropagation()}
    >
      <SnippetTechnologyTabs
        setTechnology={setTechnology}
        isTitleHidden={isTitleHidden}
      />
      {placeholder || (
        <Snippets
          technology={technology}
          hasFullWidthSnippets={hasFullWidthSnippets}
          wssCode={wssCode}
          httpCode={httpCode}
        />
      )}
    </div>
  );
};
